export const DASHLET_ACTIONS = {
  EDIT: 'edit',
  HIDE: 'hide',
  SHOW: 'show',
  DUPLICATE: 'duplicate',
  DELETE: 'delete',
  REQUEST: 'request',
};
